import { ExpandLess, ExpandMore } from "@mui/icons-material"
import PropTypes from "prop-types"

export default function ExpandIcon({ isOpen, isHidden }) {
  if (isHidden) {
    return null
  }
  if (isOpen) {
    return <ExpandLess />
  }
  return <ExpandMore />
}

ExpandIcon.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isHidden: PropTypes.bool.isRequired,
}
